import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'

interface Error {
  response: {
    status: number
  }
}

interface Response {
  data: {
    hour: string
    start_date: string
    weekday: string
    non_recurrent_reservations?: {
      successful: {
        start_date: string
        end_date: string
      }[]
      errors: {
        [date: string]: string
      }
    }
  }
}

export interface Reservation {
  hour: string
  startDate: Date
  weekday: string
  weekdayPlural: string 
  nonRecurrentReservations?: {
    successful: {
      startDate: string
      endDate: string
    }[]
    errors: {
      [date: string]: string
    }
  }
}

interface CreateReservationProps {
  professionalUsername: string
  patientUsername: string
  reservationStartDate: string
  reservationEndDate: string
  recurrent: boolean
  nonRecurrentReservations?: {
    start_date: string
    end_date: string
  }[]
}

export const createReservation = ({
  professionalUsername,
  patientUsername,
  reservationStartDate,
  reservationEndDate,
  recurrent,
  nonRecurrentReservations
}: CreateReservationProps): Promise<Reservation> => {

  //eslint-disable-next-line
  const endpoint = apiEndpoints.RESERVATION

  const params = {
    start_date: reservationStartDate,
    end_date: reservationEndDate,
    patient_username: patientUsername,
    professional_username: professionalUsername,
    recurrent,
    ...(nonRecurrentReservations && { non_recurrent_reservations: nonRecurrentReservations })
  }

  return new Promise<Reservation> ((resolve, reject) => {
    axios.post(endpoint, params)
      .then((response: Response) => {
        const result = {} as Reservation

        result.hour = response.data.hour
        result.startDate = new Date(response.data.start_date)
        result.weekday = response.data.weekday
        result.weekdayPlural = response.data.weekday.split('-').map((word) => `${word}s`).join('-')

        const { errors, successful } = response.data.non_recurrent_reservations
        result.nonRecurrentReservations = {
          successful: successful.map(item => ({
            startDate: item.start_date,
            endDate: item.end_date
          })),
          errors
        }
        
        resolve(result)
      })
      .catch((error: Error) => {
        reject(error.response.status)
      })
  })
}